// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2521":"dc54d9c4e4b20583","2888":"78dbdd1d09140e23","9256":"ae4cff51a68ba190"}[chunkId] + ".css";
};